import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { FormTemplateTitleModule } from './form-template-title/form-template-title.module';
import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';

import { FormValidatorService } from './form-validator.service';
import { FormService } from './form.service';

import { FormTemplateActionBarComponent } from './form-template-action-bar/form-template-action-bar.component';
import { FormTemplateBodyComponent } from './form-template-body/form-template-body.component';
import { FormTemplateCardPanelComponent } from './form-template-card-panel/form-template-card-panel.component';
import { FormTemplateDescriptionComponent } from './form-template-description/form-template-description.component';
import { FormTemplateExpansionPanelsComponent } from './form-template-expansion-panels/form-template-expansion-panels.component';
import { FormTemplateHeaderActionComponent } from './form-template-header-action/form-template-header-action.component';
import { FormTemplateTogglePanelComponent } from './form-template-toggle-panel/form-template-toggle-panel.component';
import { FormTemplateBodyAdvancedCheckboxComponent } from '@main-client/src/app/form/form-template-body-advanced-checkbox/form-template-body-advanced-checkbox.component';
import { FormTemplateBodyAvatarComponent } from '@main-client/src/app/form/form-template-body-avatar/form-template-body-avatar.component';
import { FormTemplateBodyCheckboxComponent } from '@main-client/src/app/form/form-template-body-checkbox/form-template-body-checkbox.component';
import { FormTemplateBodyChipsComponent } from '@main-client/src/app/form/form-template-body-chips/form-template-body-chips.component';
import { FormTemplateBodyInputComponent } from '@main-client/src/app/form/form-template-body-input/form-template-body-input.component';
import { FormTemplateBodyNumberComponent } from '@main-client/src/app/form/form-template-body-number/form-template-body-number.component';
import { FormTemplateBodySelectComponent } from '@main-client/src/app/form/form-template-body-select/form-template-body-select.component';

import { CoreModule } from '../core/core.module';
import { UploadModule } from '../upload/upload.module';

@NgModule({
  imports: [
    AvatarModule,
    CommonModule,
    CoreModule,
    FormTemplateTitleModule,
    MatExpansionModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatChipsModule,
    MatSelectModule,
    FormsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    TtcMatInputModule,
    UploadModule,
  ],
  declarations: [
    FormTemplateActionBarComponent,
    FormTemplateBodyAdvancedCheckboxComponent,
    FormTemplateBodyAvatarComponent,
    FormTemplateBodyCheckboxComponent,
    FormTemplateBodyChipsComponent,
    FormTemplateBodyInputComponent,
    FormTemplateBodyNumberComponent,
    FormTemplateBodySelectComponent,
    FormTemplateCardPanelComponent,
    FormTemplateTogglePanelComponent,
    FormTemplateExpansionPanelsComponent,
    FormTemplateDescriptionComponent,
    FormTemplateHeaderActionComponent,
    FormTemplateBodyComponent,
  ],
  providers: [FormService, FormValidatorService],
  exports: [
    FormTemplateActionBarComponent,
    FormTemplateBodyAdvancedCheckboxComponent,
    FormTemplateBodyAvatarComponent,
    FormTemplateBodyCheckboxComponent,
    FormTemplateBodyChipsComponent,
    FormTemplateBodyInputComponent,
    FormTemplateBodyNumberComponent,
    FormTemplateBodySelectComponent,
    FormTemplateCardPanelComponent,
    FormTemplateTogglePanelComponent,
    FormTemplateExpansionPanelsComponent,
    FormTemplateDescriptionComponent,
    FormTemplateBodyComponent,
  ],
})
export class FormModule {}
